import { SNACKBAR_TYPES } from "@lysaab/ui-2";
import { defineMessages } from "react-intl";
import { TrackerEvent, } from "../../eventTracker/EventTracker";
var messages = defineMessages({
    didNotIdentify: { id: "nets.did_not_identify" },
    noPopup: { id: "nets.no_popup" },
    restartJourney: { id: "nets.restart_journey" },
    timedOut: { id: "nets.timed_out" },
});
function createJourneyDefinition(flashIds, pushFlash, dropFlash, intl, setIsWaiting, setShowingSsnInfo, setIsNotACustomer, confirmIdentification, track, initiateNets) {
    var journeyDefinition = {
        initialState: "PRE_SELECT",
        PRE_SELECT: {
            actions: {
                onEnter: function () {
                    var _a;
                    setIsWaiting(false);
                    (_a = initiateNets.current) === null || _a === void 0 ? void 0 : _a.call(initiateNets).then(function () {
                        track({
                            event: TrackerEvent.NETS_PRE_SELECT,
                        });
                    });
                },
                onExit: function () { },
            },
            transitions: {
                select: {
                    target: "OPENING_POPUP",
                    action: function (eIdProvider) {
                        setIsWaiting(true);
                        flashIds.current.forEach(dropFlash);
                        flashIds.current = [];
                        track({
                            event: TrackerEvent.NETS_SELECT_PROVIDER,
                            message: { eIdProvider: eIdProvider },
                        });
                    },
                },
                netsTimedOut: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.timedOut),
                        }));
                        track({
                            event: TrackerEvent.NETS_NETS_TIMED_OUT,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsNeedCpr: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        setShowingSsnInfo(true);
                        track({
                            event: TrackerEvent.NETS_NEED_CPR,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsNotCustomer: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        setIsNotACustomer(true);
                        track({
                            event: TrackerEvent.NETS_NOT_CUSTOMER,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsError: {
                    target: "PRE_SELECT",
                    action: function (error) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.restartJourney),
                        }));
                        track({ event: TrackerEvent.NETS_NETS_ERROR, message: { error: error } });
                    },
                },
            },
        },
        OPENING_POPUP: {
            actions: {
                onEnter: function () { },
                onExit: function () { },
            },
            transitions: {
                noPopup: {
                    target: "PRE_SELECT",
                    action: function () {
                        track({
                            event: TrackerEvent.NETS_NO_POPUP,
                        });
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.noPopup),
                        }));
                    },
                },
                created: {
                    target: "POPUP_OPENED",
                    action: function (popupUrl) {
                        track({
                            event: TrackerEvent.NETS_POPUP_CREATED,
                            message: { popupUrl: popupUrl },
                        });
                    },
                },
            },
        },
        POPUP_OPENED: {
            actions: {
                onEnter: function () {
                    track({
                        event: TrackerEvent.NETS_POPUP_OPENED,
                    });
                },
                onExit: function () { },
            },
            transitions: {
                sameOriginException: {
                    target: "IDENTIFYING",
                    action: function () { },
                },
                abort: {
                    target: "PRE_SELECT",
                    action: function () {
                        track({ event: TrackerEvent.NETS_POPUP_OPENED_ABORT });
                    },
                },
            },
        },
        IDENTIFYING: {
            actions: {
                onEnter: function () {
                    track({ event: TrackerEvent.NETS_IDENTIFYING });
                },
                onExit: function () { },
            },
            transitions: {
                abort: {
                    target: "PRE_SELECT",
                    action: function () {
                        track({ event: TrackerEvent.NETS_IDENTIFYING_ABORT });
                    },
                },
                netsTimedOut: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.timedOut),
                        }));
                        track({
                            event: TrackerEvent.NETS_NETS_TIMED_OUT,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsNeedCpr: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        setShowingSsnInfo(true);
                        track({
                            event: TrackerEvent.NETS_NEED_CPR,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsNotCustomer: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        setIsNotACustomer(true);
                        track({
                            event: TrackerEvent.NETS_NOT_CUSTOMER,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsError: {
                    target: "PRE_SELECT",
                    action: function (error) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.restartJourney),
                        }));
                        track({ event: TrackerEvent.NETS_NETS_ERROR, message: { error: error } });
                    },
                },
                completed: {
                    target: "FINALIZING",
                    action: function (args) {
                        return args;
                    },
                },
            },
        },
        FINALIZING: {
            actions: {
                onEnter: function (args) {
                    track({
                        event: TrackerEvent.NETS_FINALIZING,
                        message: args,
                    });
                },
                onExit: function () { },
            },
            transitions: {
                abort: {
                    target: "PRE_SELECT",
                    action: function () {
                        track({ event: TrackerEvent.NETS_FINALIZING_ABORT });
                    },
                },
                confirm: {
                    target: "FINALIZING",
                    action: function (args) {
                        return args;
                    },
                },
                netsTimedOut: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.timedOut),
                        }));
                        track({
                            event: TrackerEvent.NETS_NETS_TIMED_OUT,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsNeedCpr: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        setShowingSsnInfo(true);
                        track({
                            event: TrackerEvent.NETS_NEED_CPR,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsNotCustomer: {
                    target: "PRE_SELECT",
                    action: function (eventData) {
                        setIsNotACustomer(true);
                        track({
                            event: TrackerEvent.NETS_NOT_CUSTOMER,
                            message: { eventData: eventData },
                        });
                    },
                },
                netsError: {
                    target: "PRE_SELECT",
                    action: function (error) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.restartJourney),
                        }));
                        track({ event: TrackerEvent.NETS_NETS_ERROR, message: { error: error } });
                    },
                },
                completed: {
                    target: "DONE",
                    action: function (args) {
                        return args;
                    },
                },
            },
        },
        DONE: {
            actions: {
                onEnter: function (args) {
                    track({
                        event: TrackerEvent.NETS_DONE,
                        message: args,
                    });
                    confirmIdentification();
                },
                onExit: function () { },
            },
            transitions: {
                confirm: {
                    target: "DONE",
                    action: function (args) {
                        return args;
                    },
                },
                completed: {
                    target: "CONFIRM_DONE",
                    action: function () { },
                },
            },
        },
        CONFIRM_DONE: {
            actions: {
                onEnter: function (args) {
                    track({ event: TrackerEvent.NETS_CONFIRM_DONE, message: args });
                },
                onExit: function () { },
            },
            transitions: {
                restartJourney: {
                    target: "PRE_SELECT",
                    action: function (message) {
                        flashIds.current.push(pushFlash({
                            type: SNACKBAR_TYPES.ERROR,
                            text: intl.formatMessage(messages.restartJourney),
                        }));
                        track({ event: TrackerEvent.NETS_CONFIRM_DONE_RESTART, message: message });
                    },
                },
                confirm: {
                    target: "CONFIRM_DONE",
                    action: function (args) {
                        return args;
                    },
                },
                completed: {
                    target: "CONFIRM_DONE",
                    action: function () {
                        track({ event: TrackerEvent.NETS_CONFIRM_DONE_COMPLETED });
                    },
                },
            },
        },
    };
    return journeyDefinition;
}
export function createJourney(flashIds, pushFlash, dropFlash, intl, setIsWaiting, setShowingSsnInfo, setIsNotACustomer, confirmIdentification, track, initiateNets) {
    var journeyDefinition = createJourneyDefinition(flashIds, pushFlash, dropFlash, intl, setIsWaiting, setShowingSsnInfo, setIsNotACustomer, confirmIdentification, track, initiateNets);
    var journey = {
        value: journeyDefinition.initialState,
        transition: function (expectedState, event, args) {
            if (expectedState !== journey.value) {
                console.error("Unexpected NetsJourney state", expectedState, "(current", journey.value, ")");
                journey.value = journeyDefinition.initialState;
                journeyDefinition[journey.value].actions.onEnter();
                flashIds.current.push(pushFlash({
                    type: SNACKBAR_TYPES.ERROR,
                    text: intl.formatMessage(messages.restartJourney),
                }));
                return;
            }
            var currentStateDefinition = journeyDefinition[journey.value];
            var destinationTransition = currentStateDefinition.transitions[event];
            if (!destinationTransition) {
                return;
            }
            var destinationState = destinationTransition.target;
            var destinationStateDefinition = journeyDefinition[destinationState];
            var actionValue = destinationTransition.action(args);
            currentStateDefinition.actions.onExit(actionValue);
            journey.value = destinationState;
            destinationStateDefinition.actions.onEnter(actionValue);
            return journey.value;
        },
    };
    journeyDefinition[journeyDefinition.initialState].actions.onEnter();
    return journey;
}
